<template>
    <a v-show="appUrl" class="store-badge" target="_blank" :href="appUrl">
        <img class="appstore" :alt="altText" :src="badgeUrl" :style="`width: ${width}`" />
    </a>
</template>

<script>
export default {
    name: 'store-badge',
    props: ['type', 'width', 'height'],
    data(){
        return {
            playstore: {
                badgeUrl: 'https://play.google.com/intl/en_us/badges/static/images/badges/ar_badge_web_generic.png',
                alt: 'احصل عليه من Google Play'
            },
            appstore: {
                badgeUrl: '/img/appstore.svg',
                alt: 'تنزيل من App Store'
            }
        }
    },
    computed: {
        storeType(){
            return this.type === 'applestore' || this.type === 'appstore' || this.type === 'apple' ? 'appstore' : 'playstore';
        },
        store(){
            let type = this.storeType;
            return this[type];
        },
        badgeUrl(){
            return this.store.badgeUrl;
        },
        altText(){
            return this.store.alt;
        },
        appData(){
            return this.$store.state.globalModule.appData;
        },
        appUrl(){
            if (this.storeType === 'appstore'){
                return (this.appData && this.appData.apple_store_url) || 'https://apps.apple.com/eg/app/codingwithghonaim/id6778895200';
            }
            return (this.appData && this.appData.play_store_url) || 'https://play.google.com/store/apps/details?id=com.codingwithghonaim.app';
        }
    }
}
</script>

<style lang="scss" scoped>
    .store-badge{
        transition: 0.15s ease-out all;
        display: flex;
        /* &:active{
            transform: scale(0.93);
        } */
    }
</style>